<main>
    <div class="login_left">
      <h1>Prêt à bouger et t’amuser ?</h1>
      <h3>Viens t'amuser avec <b>Acajoux</b> </h3>
      <a href="https://jeuxdelacadie.org/les-etoiles/">En savoir plus sur les Étoiles</a>
    </div>
    <div class="login_right">
      <img class="acadie_logo" src="../assets/icons/JeuxAcadie_signature_horizontal 1.svg" alt="Jeux-de-l-acadie_logo">
      <h1 class="login_bienvenue">Bienvenue aux <b  style="color: #D4AB16">Étoiles d'Acajoux!</b></h1>
      <div class="login-form">
        <mat-form-field class="login_inputs login_courriel">
          <mat-label>Courriel</mat-label>
          <input type="email" matInput placeholder="Ex. johndoe@email.ca" [(ngModel)]="courriel">
        </mat-form-field>
  
        <mat-form-field class="login_inputs login_mdp">
          <mat-label>Mot de passe</mat-label>
          <input type="{{passwordState}}" matInput [(ngModel)]="mdp">
        </mat-form-field>
      </div>
      <div class="postPasswordInput">
        <label for="showPass">
          <input (click)="managePasswordState()" type="checkbox" name="showPass">
          <p>Afficher le mot de passe</p>
        </label>
        <p class="login_mdp_oublie" (click)="this.app.navigateTo('/recuperer_mdp')">Mot de passe oublié ?</p>
      </div>
      <button class="btn_se_connecter" (click)="seConnecter()">Se connecter</button>
      <p>Nouvel utilisateur? <b style="color: #D4AB16; cursor: pointer;" (click)="this.app.navigateTo('/s_inscrire')">S'enregistrer</b></p>
    </div>
  </main>